<template>
  <div>
    <!-- 列表模式 -->
    <template v-if="!printMode">
    <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <store-tenant-select domain="sale" @change="handleStoreTenantChange"></store-tenant-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入单据编号" v-model="queryParam.number"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="单据日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker
                    style="width: 100%"
                    v-model="queryParam.dateRange"
                    format="YYYY-MM-DD"
                    :placeholder="['开始日期', '结束日期']"
                    @change="onDateChange"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <a-button style="margin-left: 8px" icon="printer" v-if="btnEnableList.indexOf('5')>-1"
                    @click="handlePrint">打印</a-button>
                  <a-button style="margin-left: 8px" @click="exportExcel" icon="download" v-if="btnEnableList.indexOf('3')>-1">导出</a-button>
                  <a @click="toggleSearchStatus = !toggleSearchStatus" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
            <template v-if="toggleSearchStatus">
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="商品" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入条码、名称、助记码、规格、型号等信息" v-model="queryParam.materialParam"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="客户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="请选择客户" v-model="queryParam.organId"
                              :dropdownMatchSelectWidth="false" showSearch allow-clear
                              optionFilterProp="children" @search="handleSearchOrgan">
                      <a-select-option v-for="(item,index) in organList" :key="index" :value="item.id">
                        {{ item.supplier }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select
                      placeholder="请选择仓库"
                      allow-clear
                      style="width: 100%"
                      v-model="queryParam.depotId">
                      <a-select-option v-for="(item, index) in depotList" :key="index" :value="item.id">
                        {{ item.depotName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-tree-select
                      style="width: 100%"
                      :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                      allow-clear
                      :treeData="categoryTree"
                      v-model="queryParam.categoryId"
                      placeholder="请选择类别">
                    </a-tree-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="关联单据" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入关联单据" v-model="queryParam.linkNumber"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="销售人员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="请选择销售人员" showSearch allow-clear
                              optionFilterProp="children" v-model="queryParam.salesMan">
                      <a-select-option v-for="(item,index) in personList" :key="index" :value="item.id">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="操作员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="请选择操作员" showSearch allow-clear
                              optionFilterProp="children" v-model="queryParam.creator">
                      <a-select-option v-for="(item,index) in userList" :key="index" :value="item.id">
                        {{ item.userName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </a-form>
        </div>
        <section ref="print" id="reportPrint">
          <a-table
            bordered
            ref="table"
            size="middle"
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
            <span slot="numberCustomRender" slot-scope="text, record">
              <a @click="handleNumberClick(record)">{{ record.number }}</a>
            </span>
          </a-table>
          <a-row :gutter="24" style="margin-top: 8px; textAlign: right">
            <a-col :md="24" :sm="24">
              <a-pagination
                @change="paginationChange"
                @showSizeChange="paginationShowSizeChange"
                size="small"
                show-size-changer
                show-quick-jumper
                :current="ipagination.current"
                :page-size="ipagination.pageSize"
                :page-size-options="ipagination.pageSizeOptions"
                :total="ipagination.total"
              />
            </a-col>
          </a-row>
        </section>
      </a-card>
    </a-col>
    </a-row>
    </template>

    <!-- 打印模式 -->
    <template v-if="printMode">
      <div class="print-header" style="display:flex; justify-content:space-between; align-items:center; padding:8px 16px; background:#fff; border-bottom:1px solid #e8e8e8; margin-bottom:12px;">
        <span style="font-size:16px; font-weight:500;">{{ printTitle }}</span>
        <a-button icon="close" @click="printMode = false">关闭</a-button>
      </div>
      <ReportPrint
        :visible="true"
        :tableData="printDataSource"
        :queryParam="queryParam"
        billType="SALE_PROFIT"
        billTypeName="销售利润"
        :buildData="buildPrintData"
        :embedded="true"
        @designer-change="onDesignerChange"
        @back="printMode = false"
      />
    </template>
  </div>
</template>
<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getUserList, findBySelectCus, queryMaterialCategoryTreeList } from '@/api/api'
  import { getAction } from '@/api/manage'
  import moment from 'moment'
  import { getPrevMonthFormatDate, getFormatDate } from '@/utils/util'
  import ReportPrint from '@/views/plugin/print-template/ReportPrint.vue'
  import StoreTenantSelect from '@/components/StoreTenantSelect'
  import { defColumns, buildPrintData } from './saleProfitConfig'

  export default {
    name: "SaleProfitList",
    mixins: [JeecgListMixin],
    components: {
      ReportPrint,
      StoreTenantSelect
    },
    data() {
      return {
        labelCol: { span: 6 },
        wrapperCol: { span: 17, offset: 1 },
        queryParam: {
          number: '',
          linkNumber: '',
          materialParam: '',
          organId: undefined,
          depotId: undefined,
          categoryId: undefined,
          creator: undefined,
          salesMan: undefined,
          beginTime: getPrevMonthFormatDate(3),
          endTime: getFormatDate(),
          dateRange: [moment(getPrevMonthFormatDate(3)), moment(getFormatDate())]
        },
        ipagination: {
          current: 1,
          pageSize: 11,
          pageSizeOptions: ['10', '20', '30', '50', '100'],
          total: 0
        },
        organList: [],
        depotList: [],
        userList: [],
        personList: [],
        categoryTree: [],
        columns: [],
        defColumns: defColumns,
        url: {
          list: '/api/plugin/sale-profit/saleProfit/getList'
        },
        urlPath: '/plugin/sale_profit',
        printDataSource: [],
        printMode: false,
        printTitle: '销售利润-打印预览',
        isorter: {
          column: 'operNumber',
          order: 'desc'
        }
      }
    },
    created() {
      this.columns = this.defColumns
      this.initOrgan()
      this.getDepotData()
      this.initUser()
      this.initPerson()
      this.loadCategoryTreeData()
    },
    methods: {
      moment,
      buildPrintData,
      handleStoreTenantChange() {
        this.searchQuery()
      },
      async fetchAllData() {
        const pageSize = 500
        let allRows = []
        let total = 0

        const baseParams = {
          number: this.queryParam.number || undefined,
          linkNumber: this.queryParam.linkNumber || undefined,
          materialParam: this.queryParam.materialParam || undefined,
          organId: this.queryParam.organId || undefined,
          depotId: this.queryParam.depotId || undefined,
          categoryId: this.queryParam.categoryId || undefined,
          creator: this.queryParam.creator || undefined,
          salesMan: this.queryParam.salesMan || undefined,
          beginTime: this.queryParam.beginTime || undefined,
          endTime: this.queryParam.endTime || undefined,
          column: this.isorter.column || 'operNumber',
          order: this.isorter.order || 'desc',
          pageSize: pageSize
        }

        // 先获取第一页，拿到 total
        const firstParams = { ...baseParams, currentPage: 1 }
        const firstRes = await getAction(this.url.list, firstParams)
        if (firstRes && firstRes.code === 200 && firstRes.data) {
          total = firstRes.data.total || 0
          const rows = firstRes.data.rows || []
          allRows = allRows.concat(rows)
        }

        // 循环获取剩余页
        const totalPages = Math.ceil(total / pageSize)
        for (let page = 2; page <= totalPages; page++) {
          const params = { ...baseParams, currentPage: page }
          const res = await getAction(this.url.list, params)
          if (res && res.code === 200 && res.data) {
            const rows = res.data.rows || []
            allRows = allRows.concat(rows)
          }
        }

        // 添加 rowIndex
        allRows.forEach((row, i) => {
          row.rowIndex = i + 1
        })

        // 追加合计行
        this.addTotalRow(allRows)

        return allRows
      },
      addTotalRow(dataSource) {
        if (dataSource.length === 0) return
        const totalRow = { rowIndex: '合计' }
        const sumFields = ['operNumber', 'unitPrice', 'purchaseUnitPrice', 'salePrice', 'purchasePrice', 'profitPrice']
        const textFields = ['profitRate', 'taxRate']

        sumFields.forEach(field => {
          let total = 0
          dataSource.forEach(row => {
            if (row[field]) {
              total += Number.parseFloat(row[field])
            }
          })
          totalRow[field] = parseFloat(total.toFixed(2))
        })

        textFields.forEach(field => {
          totalRow[field] = '-'
        })

        dataSource.push(totalRow)
      },
      async handlePrint() {
        this.loading = true
        try {
          const allRows = await this.fetchAllData()
          if (!allRows || allRows.length === 0) {
            this.$message.warning('暂无数据可打印')
            return
          }
          this.printDataSource = allRows
          this.printTitle = '销售利润-打印预览'
          this.printMode = true
        } catch (err) {
          this.$message.error('获取打印数据失败: ' + (err.message || '未知错误'))
          console.error(err)
        } finally {
          this.loading = false
        }
      },
      onDesignerChange(visible) {
        this.printTitle = visible ? '销售利润-报表设计' : '销售利润-打印预览'
      },
      onDateChange(value, dateString) {
        if (dateString && dateString.length === 2) {
          this.queryParam.beginTime = dateString[0]
          this.queryParam.endTime = dateString[1]
        }
      },
      loadData() {
        const params = {
          number: this.queryParam.number || undefined,
          linkNumber: this.queryParam.linkNumber || undefined,
          materialParam: this.queryParam.materialParam || undefined,
          organId: this.queryParam.organId || undefined,
          depotId: this.queryParam.depotId || undefined,
          categoryId: this.queryParam.categoryId || undefined,
          creator: this.queryParam.creator || undefined,
          salesMan: this.queryParam.salesMan || undefined,
          beginTime: this.queryParam.beginTime || undefined,
          endTime: this.queryParam.endTime || undefined,
          column: this.isorter.column || 'operNumber',
          order: this.isorter.order || 'desc',
          currentPage: this.ipagination.current,
          pageSize: this.ipagination.pageSize - 1
        }
        this.loading = true
        getAction(this.url.list, params).then((res) => {
          if (res && res.code === 200 && res.data) {
            const rows = res.data.rows || []
            rows.forEach((row, i) => {
              row.rowIndex = (this.ipagination.current - 1) * (this.ipagination.pageSize - 1) + i + 1
            })
            this.dataSource = rows
            this.ipagination.total = res.data.total || 0
            this.tableAddTotalRow(this.columns, this.dataSource)
          } else if (res && res.code === 510) {
            this.$message.warning(res.data)
          } else {
            this.dataSource = []
            this.ipagination.total = 0
          }
          this.loading = false
        }).catch((err) => {
          this.loading = false
          this.$message.error('查询失败: ' + (err.message || '未知错误'))
          console.error(err)
        })
      },
      tableAddTotalRow(columns, dataSource) {
        if (dataSource.length > 0) {
          let numKey = 'rowIndex'
          let totalRow = { [numKey]: '合计' }
          let parseCols = 'operNumber,unitPrice,purchaseUnitPrice,salePrice,purchasePrice,profitPrice,'
          columns.forEach(column => {
            let { key, dataIndex } = column
            if (![key, dataIndex].includes(numKey)) {
              let total = 0
              let hasSum = false
              dataSource.forEach(data => {
                if (parseCols.indexOf(dataIndex + ',') > -1) {
                  hasSum = true
                  if (data[dataIndex]) {
                    total += Number.parseFloat(data[dataIndex])
                  }
                }
              })
              if (hasSum) {
                totalRow[dataIndex] = total.toFixed(2)
              } else {
                totalRow[dataIndex] = ''
              }
            }
          })
          dataSource.push(totalRow)
          let size = Math.ceil(this.ipagination.total / (this.ipagination.pageSize - 1))
          this.ipagination.total = this.ipagination.total + size
        }
      },
      handleNumberClick(record) {
        const number = record.number
        if (!number) return
        // LSCK→零售出库, LSTH→零售退货, XSCK→销售出库, XSTH→销售退货
        if (number.indexOf('LSCK') === 0) {
          this.$router.push({ path: '/bill/retail_out' })
        } else if (number.indexOf('LSTH') === 0) {
          this.$router.push({ path: '/bill/retail_back' })
        } else if (number.indexOf('XSCK') === 0) {
          this.$router.push({ path: '/bill/sale_out' })
        } else if (number.indexOf('XSTH') === 0) {
          this.$router.push({ path: '/bill/sale_back' })
        }
      },
      initOrgan() {
        let that = this
        findBySelectCus({ limit: 1 }).then((res) => {
          if (res) {
            that.organList = res
          }
        })
      },
      handleSearchOrgan(value) {
        let that = this
        if (this.setTimeFlag != null) {
          clearTimeout(this.setTimeFlag)
        }
        this.setTimeFlag = setTimeout(() => {
          findBySelectCus({ key: value, limit: 1 }).then((res) => {
            if (res) {
              that.organList = res
            }
          })
        }, 500)
      },
      getDepotData() {
        getAction('/depot/findDepotByCurrentUser').then((res) => {
          if (res.code === 200) {
            this.depotList = res.data
          } else {
            this.$message.info(res.data)
          }
        })
      },
      initUser() {
        getUserList({}).then((res) => {
          if (res) {
            this.userList = res
          }
        })
      },
      initPerson() {
        getAction('/person/getPersonByType', { type: '财务员' }).then((res) => {
          if (res.code === 200) {
            this.personList = res.data.personList || []
          }
        })
      },
      loadCategoryTreeData() {
        queryMaterialCategoryTreeList({ id: '' }).then((res) => {
          if (res) {
            this.categoryTree = []
            for (let i = 0; i < res.length; i++) {
              this.categoryTree.push(res[i])
            }
          }
        })
      },
      searchQuery() {
        this.ipagination.current = 1
        this.loadData()
      },
      searchReset() {
        this.queryParam = {
          number: '',
          linkNumber: '',
          materialParam: '',
          organId: undefined,
          depotId: undefined,
          categoryId: undefined,
          creator: undefined,
          salesMan: undefined,
          beginTime: getPrevMonthFormatDate(3),
          endTime: getFormatDate(),
          dateRange: [moment(getPrevMonthFormatDate(3)), moment(getFormatDate())]
        }
        this.ipagination.current = 1
        this.loadData()
      },
      handleTableChange(pagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          if (sorter.order) {
            this.isorter.column = sorter.field
            this.isorter.order = 'ascend' === sorter.order ? 'asc' : 'desc'
          } else {
            this.isorter.column = 'operNumber'
            this.isorter.order = 'desc'
          }
        }
        if (pagination && pagination.current) {
          this.ipagination = pagination
        }
        this.loadData()
      },
      paginationChange(page, pageSize) {
        this.ipagination.current = page
        this.ipagination.pageSize = pageSize
        this.loadData()
      },
      paginationShowSizeChange(current, size) {
        this.ipagination.current = 1
        this.ipagination.pageSize = size
        this.loadData()
      },
      async exportExcel() {
        this.loading = true
        try {
          const allRows = await this.fetchAllData()
          if (!allRows || allRows.length === 0) {
            this.$message.warning('暂无数据可导出')
            return
          }

          const list = []
          const exportHead = '单据编号,条码,名称,规格,型号,单位,数量,销售单价,成本价,销售金额,成本金额,利润,利润率,税率,客户或会员'

          for (let i = 0; i < allRows.length; i++) {
            const ds = allRows[i]
            list.push([
              ds.number || '',
              ds.barCode || '',
              ds.mName || '',
              ds.standard || '',
              ds.model || '',
              ds.mUnit || '',
              ds.operNumber || 0,
              ds.unitPrice || 0,
              ds.purchaseUnitPrice || 0,
              ds.salePrice || 0,
              ds.purchasePrice || 0,
              ds.profitPrice || 0,
              ds.profitRate || 0,
              ds.taxRate || 0,
              ds.sName || ''
            ])
          }

          let tip = '单据日期：' + this.queryParam.beginTime + '~' + this.queryParam.endTime

          // 合计行
          let totalItem = ['-', '-', '-', '-', '-', '-', 0, 0, 0, 0, 0, 0, '-', '-', '-']
          for (let i = 0; i < allRows.length; i++) {
            const ds = allRows[i]
            totalItem[6] += Number.parseFloat(ds.operNumber || 0)
            totalItem[7] += Number.parseFloat(ds.unitPrice || 0)
            totalItem[8] += Number.parseFloat(ds.purchaseUnitPrice || 0)
            totalItem[9] += Number.parseFloat(ds.salePrice || 0)
            totalItem[10] += Number.parseFloat(ds.purchasePrice || 0)
            totalItem[11] += Number.parseFloat(ds.profitPrice || 0)
          }
          totalItem[6] = totalItem[6].toFixed(2)
          totalItem[7] = totalItem[7].toFixed(2)
          totalItem[8] = totalItem[8].toFixed(2)
          totalItem[9] = totalItem[9].toFixed(2)
          totalItem[10] = totalItem[10].toFixed(2)
          totalItem[11] = totalItem[11].toFixed(2)
          list.push(totalItem)

          this.handleExportXlsPost('销售利润', '销售利润', exportHead, tip, list)
        } catch (err) {
          this.$message.error('导出失败: ' + (err.message || '未知错误'))
          console.error(err)
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>
<style scoped>
</style>